import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column'
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';

export class OnDropdownFilteredEventArgs<T extends Slick.SlickData> {
    constructor(public readonly column: ISlickGridColumn<T>, public readonly type: DropdownFilterType, public readonly value?: any) {
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/on-dropdown-filtered-event-args.ts